var render = function() {
  var this$1 = this
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-overlay",
    { attrs: { show: _vm.loading } },
    [
      _vm.inPreview
        ? _c(
            "div",
            [
              _vm.pdfUrl
                ? _c(
                    "a",
                    { attrs: { href: _vm.pdfUrl, target: "_blank" } },
                    [
                      _c(
                        "h5",
                        {
                          staticClass:
                            "text-primary underline d-inline-block mr-2",
                          attrs: { "data-cy": "document-viewer" }
                        },
                        [
                          _vm._v(" * Visualizando documento "),
                          _c("small", [_vm._v("(Guía de Recepción Conforme)")]),
                          _vm._v(" * ")
                        ]
                      ),
                      _c("feather-icon", {
                        attrs: { icon: "ExternalLinkIcon" }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _c("pdf-preview-complete", {
                attrs: {
                  inPreview: _vm.inPreview,
                  generatingPreview: _vm.generatingPreview,
                  saving: _vm.saving,
                  pdfUrl: _vm.pdfUrl,
                  backToForm: _vm.backToForm,
                  save: _vm.save
                },
                on: {
                  "in-preview": function($event) {
                    _vm.inPreview = $event
                  }
                }
              })
            ],
            1
          )
        : _c(
            "div",
            [
              _c(
                "form",
                {
                  attrs: { autocomplete: "off" },
                  on: {
                    submit: function($event) {
                      $event.preventDefault()
                    }
                  }
                },
                [
                  _c("h2", [_vm._v("GUÍA DE RECEPCIÓN CONFORME")]),
                  _c("div", { staticClass: "row mt-10" }, [
                    _c(
                      "div",
                      { staticClass: "col-12" },
                      [
                        _c(
                          "b-form-group",
                          [
                            _c(
                              "label",
                              { attrs: { for: "previousDocument" } },
                              [_vm._v(" ¿Deseas basarte en otro documento? ")]
                            ),
                            _c(
                              "v-select",
                              {
                                attrs: {
                                  options: _vm.createdDocuments,
                                  name: "previousDocument",
                                  label: "label",
                                  "data-cy": "created-document-data",
                                  clearable: true
                                },
                                on: {
                                  input: function($event) {
                                    return _vm.getDocumentData($event)
                                  }
                                },
                                model: {
                                  value: _vm.previousDocument,
                                  callback: function($$v) {
                                    _vm.previousDocument = $$v
                                  },
                                  expression: "previousDocument"
                                }
                              },
                              [
                                _c("template", { slot: "no-options" }, [
                                  _vm._v(" no hay documentos registrados ")
                                ])
                              ],
                              2
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]),
                  _c(
                    "div",
                    { staticClass: "row" },
                    [
                      !_vm.attachments || !_vm.attachments.length
                        ? _c(
                            "div",
                            { staticClass: "col-12 mb-4" },
                            [
                              _c(
                                "b-button",
                                {
                                  directives: [
                                    {
                                      name: "has-permission",
                                      rawName: "v-has-permission",
                                      value: "ED060",
                                      expression: "'ED060'"
                                    },
                                    {
                                      name: "b-modal",
                                      rawName: "v-b-modal",
                                      value: "add-repository-file",
                                      expression: "'add-repository-file'"
                                    }
                                  ],
                                  staticClass: "btn-icon mt-1 w-100",
                                  attrs: {
                                    variant: "secondary",
                                    "data-cy": "from-repository",
                                    disabled: _vm.attachments.length >= 1
                                  }
                                },
                                [
                                  _c("feather-icon", {
                                    attrs: { icon: "ServerIcon" }
                                  }),
                                  _vm._v(
                                    " Seleccionar FISABS/FCA desde el repositorio "
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._l(_vm.attachments, function(file) {
                        return _c(
                          "div",
                          { key: file.id, staticClass: "col-12" },
                          [
                            file && file.name && file.name.includes("FISABS")
                              ? _c(
                                  "div",
                                  { staticClass: "row align-items-center" },
                                  [
                                    _c("vs-icon", {
                                      staticClass: "col-2",
                                      attrs: {
                                        icon: "description",
                                        size: "25px",
                                        color: "primary"
                                      }
                                    }),
                                    _c(
                                      "b",
                                      {
                                        staticClass: "w-100 text-center col-8"
                                      },
                                      [_vm._v(_vm._s(file.name))]
                                    ),
                                    _c("vs-button", {
                                      staticClass: "col-2",
                                      attrs: {
                                        color: "danger",
                                        type: "flat",
                                        icon: "clear"
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.removeRepositoryFile(
                                            file.id
                                          )
                                        }
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e()
                          ]
                        )
                      }),
                      !_vm.attachments || !_vm.attachments.length
                        ? _c("div", { staticClass: "col-12" }, [
                            _c(
                              "span",
                              {
                                staticClass:
                                  "danger span-text-validation-danger v-enter-to"
                              },
                              [
                                _c("small", [
                                  _vm._v(
                                    " Debes seleccionar un archivo desde el repositorio "
                                  )
                                ])
                              ]
                            )
                          ])
                        : _vm._e()
                    ],
                    2
                  ),
                  _vm.attachments && _vm.attachments.length && !_vm.loading
                    ? _c(
                        "div",
                        { staticClass: "row" },
                        [
                          _c(
                            "div",
                            { staticClass: "col-12" },
                            [_c("vs-divider")],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "col-6" },
                            [
                              _c("validate-field", {
                                attrs: {
                                  field: "orderNumber",
                                  label: "N° Orden de Compra"
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function(ref) {
                                        var invalid = ref.invalid
                                        return [
                                          _c("b-input", {
                                            attrs: {
                                              name: "orderNumber",
                                              placeholder:
                                                "Número de Orden de Compra",
                                              "data-vv-as":
                                                "número de Orden de Compra",
                                              "data-cy": "order-number",
                                              state: invalid
                                            },
                                            model: {
                                              value: _vm.formData.orderNumber,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.formData,
                                                  "orderNumber",
                                                  $$v
                                                )
                                              },
                                              expression: "formData.orderNumber"
                                            }
                                          })
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  705371098
                                )
                              })
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "col-6" },
                            [
                              _c("validate-field", {
                                attrs: {
                                  field: "receiverGroup",
                                  label: "Dirección /Dpto. /Unidad que Recibe"
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function(ref) {
                                        var invalid = ref.invalid
                                        return [
                                          _c("select-options", {
                                            directives: [
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value: "required",
                                                expression: "'required'"
                                              }
                                            ],
                                            attrs: {
                                              name: "receiverGroup",
                                              "alphabetical-sort": true,
                                              "options-group":
                                                "fisabs-requester-unit",
                                              "data-vv-as": "unidad requirente",
                                              "data-cy": "receiver-group",
                                              invalid: invalid
                                            },
                                            model: {
                                              value: _vm.formData.receiverGroup,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.formData,
                                                  "receiverGroup",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "formData.receiverGroup"
                                            }
                                          })
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  86527065
                                )
                              })
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "col-6" },
                            [
                              _c("validate-field", {
                                attrs: {
                                  field: "deliveryDate",
                                  label: "Fecha Entrega/ofertado según OC"
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function(ref) {
                                        var invalid = ref.invalid
                                        return [
                                          _c("date-picker", {
                                            directives: [
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value: "required",
                                                expression: "'required'"
                                              }
                                            ],
                                            attrs: {
                                              name: "deliveryDate",
                                              format: "YYYY-MM-DD",
                                              "value-type": "YYYY-MM-DD",
                                              placeholder:
                                                "Seleccione la fecha de entrega",
                                              "data-vv-as": "fecha de entrega",
                                              "data-cy": "delivery-date",
                                              invalid: invalid
                                            },
                                            model: {
                                              value: _vm.formData.deliveryDate,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.formData,
                                                  "deliveryDate",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "formData.deliveryDate"
                                            }
                                          })
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  93176324
                                )
                              })
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "col-6" },
                            [
                              _c("validate-field", {
                                attrs: {
                                  field: "receptionDate",
                                  label:
                                    "Fecha Recepción Conforme del bien o servicio"
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function(ref) {
                                        var invalid = ref.invalid
                                        return [
                                          _c("date-picker", {
                                            directives: [
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value: "required",
                                                expression: "'required'"
                                              }
                                            ],
                                            attrs: {
                                              name: "receptionDate",
                                              format: "YYYY-MM-DD",
                                              "value-type": "YYYY-MM-DD",
                                              placeholder:
                                                "Seleccione la fecha de recepción",
                                              "data-vv-as":
                                                "fecha de recepción",
                                              "data-cy": "reception-date",
                                              invalid: invalid
                                            },
                                            model: {
                                              value: _vm.formData.receptionDate,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.formData,
                                                  "receptionDate",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "formData.receptionDate"
                                            }
                                          })
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  2460413829
                                )
                              })
                            ],
                            1
                          ),
                          _c("div", { staticClass: "col-12" }, [
                            _c("h4", [_vm._v("CONTRAPARTE DE LA COMPRA")])
                          ]),
                          _c(
                            "div",
                            { staticClass: "col-6" },
                            [
                              _c("validate-field", {
                                attrs: {
                                  field: "requesterName",
                                  label: "Responsable de elaborar la solicitud"
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function(ref) {
                                        var invalid = ref.invalid
                                        return [
                                          _c("ListUser", {
                                            directives: [
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value: "required",
                                                expression: "'required'"
                                              }
                                            ],
                                            staticClass: "w-100 mb-0",
                                            attrs: {
                                              autocomplete: "",
                                              label: " ",
                                              name: "requesterName",
                                              invalid: invalid,
                                              danger: _vm.errors.has(
                                                "formData.requesterName"
                                              ),
                                              state: _vm.errors.has(
                                                "formData.requesterName"
                                              ),
                                              "danger-text": _vm.errors.first(
                                                "formData.requesterName"
                                              ),
                                              "data-vv-as":
                                                "responsable de elaborar la solicitud",
                                              "data-cy": "requester-name"
                                            },
                                            on: {
                                              "full-user": _vm.setRequester
                                            },
                                            model: {
                                              value: _vm.formData.requesterName,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.formData,
                                                  "requesterName",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "formData.requesterName"
                                            }
                                          })
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  3312918555
                                )
                              })
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "col-6" },
                            [
                              _c("validate-field", {
                                attrs: {
                                  field: "requesterUnit",
                                  label: "Unidad requirente"
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function(ref) {
                                        var invalid = ref.invalid
                                        return [
                                          _c("select-options", {
                                            directives: [
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value: "required",
                                                expression: "'required'"
                                              }
                                            ],
                                            attrs: {
                                              name: "requesterUnit",
                                              "alphabetical-sort": true,
                                              "options-group":
                                                "fisabs-requester-unit",
                                              "data-vv-as": "unidad requirente",
                                              "data-cy": "requester-unit",
                                              invalid: invalid
                                            },
                                            model: {
                                              value: _vm.formData.requesterUnit,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.formData,
                                                  "requesterUnit",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "formData.requesterUnit"
                                            }
                                          })
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  2096487935
                                )
                              })
                            ],
                            1
                          ),
                          _c("div", { staticClass: "col-12" }, [
                            _c("h4", [_vm._v("IDENTIFICACIÓN DEL PROVEEDOR")])
                          ]),
                          _c(
                            "div",
                            { staticClass: "col-6" },
                            [
                              _c("validate-field", {
                                attrs: { field: "iutProvider", label: "Rut" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function(ref) {
                                        var invalid = ref.invalid
                                        return [
                                          _c("b-input", {
                                            directives: [
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value: "required",
                                                expression: "'required'"
                                              }
                                            ],
                                            attrs: {
                                              name: "iutProvider",
                                              placeholder: "Ingrese el rut",
                                              "data-vv-as": "rut proveedor",
                                              "data-cy": "iut-provider",
                                              state: invalid
                                            },
                                            model: {
                                              value: _vm.formData.iutProvider,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.formData,
                                                  "iutProvider",
                                                  $$v
                                                )
                                              },
                                              expression: "formData.iutProvider"
                                            }
                                          })
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  2872632973
                                )
                              })
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "col-6" },
                            [
                              _c("validate-field", {
                                attrs: {
                                  field: "businessNameProvider",
                                  label: "Razón Social"
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function(ref) {
                                        var invalid = ref.invalid
                                        return [
                                          _c("b-input", {
                                            directives: [
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value: "required",
                                                expression: "'required'"
                                              }
                                            ],
                                            attrs: {
                                              name: "businessNameProvider",
                                              placeholder:
                                                "Ingrese la razón social",
                                              "data-vv-as":
                                                "razón social proveedor",
                                              "data-cy":
                                                "business-name-provider",
                                              state: invalid
                                            },
                                            model: {
                                              value:
                                                _vm.formData
                                                  .businessNameProvider,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.formData,
                                                  "businessNameProvider",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "formData.businessNameProvider"
                                            }
                                          })
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  1508549101
                                )
                              })
                            ],
                            1
                          ),
                          _c("div", { staticClass: "col-12" }, [
                            _c("h4", [_vm._v("IDENTIFICACIÓN DE LA COMPRA")])
                          ]),
                          _c(
                            "div",
                            { staticClass: "col-6" },
                            [
                              _c(
                                "b-form-group",
                                { staticClass: "mt-0 mt-md-8" },
                                [
                                  _c(
                                    "b-form-checkbox",
                                    {
                                      staticClass: "m-0",
                                      attrs: {
                                        name: "paymentOfService",
                                        "data-cy": "payment-of-service",
                                        "data-vv-as":
                                          "se paga un servicio o producto"
                                      },
                                      model: {
                                        value: _vm.formData.paymentOfService,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.formData,
                                            "paymentOfService",
                                            $$v
                                          )
                                        },
                                        expression: "formData.paymentOfService"
                                      }
                                    },
                                    [_vm._v(" Se paga un servicio o producto ")]
                                  ),
                                  _c(
                                    "b-form-checkbox",
                                    {
                                      staticClass: "m-0",
                                      attrs: {
                                        name: "paymentMonthly",
                                        "data-cy": "payment-monthly",
                                        "data-vv-as":
                                          "se paga un monto fijo mensual"
                                      },
                                      model: {
                                        value: _vm.formData.paymentMonthly,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.formData,
                                            "paymentMonthly",
                                            $$v
                                          )
                                        },
                                        expression: "formData.paymentMonthly"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        " Se paga un monto fijo mensual según contrato (contrato mayor a 2 meses) "
                                      )
                                    ]
                                  ),
                                  _c(
                                    "b-form-checkbox",
                                    {
                                      staticClass: "m-0",
                                      attrs: {
                                        name: "paymentVariable",
                                        "data-cy": "payment-variable",
                                        "data-vv-as":
                                          "se paga un monto variable"
                                      },
                                      model: {
                                        value: _vm.formData.paymentVariable,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.formData,
                                            "paymentVariable",
                                            $$v
                                          )
                                        },
                                        expression: "formData.paymentVariable"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        " Se paga un monto según contrato (cuando es contrato de suministro; o la contratación lo indica, el monto de la cuota o periodicidad se indica en el contrato u orden de compra). "
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c("div", { staticClass: "col-6" }),
                          _c(
                            "div",
                            { staticClass: "col-6" },
                            [
                              _c(
                                "validate-field",
                                {
                                  attrs: {
                                    field: "numberOfQuota",
                                    label: "Número pago o cuota"
                                  }
                                },
                                [
                                  _c("b-input", {
                                    attrs: {
                                      name: "numberOfQuotas",
                                      "data-vv-as": "número de pago o cuota",
                                      "data-cy": "number-of-quota"
                                    },
                                    model: {
                                      value: _vm.formData.numberOfQuota,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.formData,
                                          "numberOfQuota",
                                          $$v
                                        )
                                      },
                                      expression: "formData.numberOfQuota"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "col-6" },
                            [
                              _c(
                                "validate-field",
                                {
                                  attrs: {
                                    field: "numberOrderApproval",
                                    label:
                                      "N° Resolución que aprueba la contratación"
                                  }
                                },
                                [
                                  _c("b-input", {
                                    attrs: {
                                      name: "numberOrderApproval",
                                      "data-vv-as": "número de Resolución",
                                      "data-cy": "number-order-approval"
                                    },
                                    model: {
                                      value: _vm.formData.numberOrderApproval,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.formData,
                                          "numberOrderApproval",
                                          $$v
                                        )
                                      },
                                      expression: "formData.numberOrderApproval"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c("div", { staticClass: "col-12" }, [
                            _c("div", { staticClass: "row" }, [
                              _c(
                                "div",
                                { staticClass: "col-12" },
                                [
                                  _c("validate-field", {
                                    attrs: {
                                      field: "taxType",
                                      label: "Tipo de Impuesto"
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function(ref) {
                                            var invalid = ref.invalid
                                            return [
                                              _c(
                                                "v-select",
                                                {
                                                  directives: [
                                                    {
                                                      name: "validate",
                                                      rawName: "v-validate",
                                                      value: "required",
                                                      expression: "'required'"
                                                    }
                                                  ],
                                                  attrs: {
                                                    options: _vm.taxTypeOptions,
                                                    placeholder:
                                                      "Seleccione tipo de impuesto",
                                                    name: "taxType",
                                                    reduce: function(option) {
                                                      return option.value
                                                    },
                                                    "data-vv-as":
                                                      "tipo de impuesto",
                                                    "data-cy": "tax-type"
                                                  },
                                                  on: {
                                                    input: _vm.onTaxTypeChange
                                                  },
                                                  model: {
                                                    value: _vm.formData.taxType,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.formData,
                                                        "taxType",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "formData.taxType"
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "template",
                                                    { slot: "no-options" },
                                                    [
                                                      _vm._v(
                                                        " no hay opciones disponibles "
                                                      )
                                                    ]
                                                  )
                                                ],
                                                2
                                              )
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      false,
                                      774390929
                                    )
                                  })
                                ],
                                1
                              ),
                              _vm.isOtros
                                ? _c(
                                    "div",
                                    { staticClass: "col-4" },
                                    [
                                      _c("label", [
                                        _vm._v("Tasa de Impuesto (%)")
                                      ]),
                                      _c("vs-input", {
                                        staticClass: "w-100",
                                        attrs: {
                                          type: "number",
                                          "data-cy": "tax-rate",
                                          size: "small",
                                          min: "0",
                                          max: "100",
                                          step: "0.01"
                                        },
                                        on: { input: _vm.calculateTotals },
                                        model: {
                                          value: _vm.formData.taxRate,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formData,
                                              "taxRate",
                                              $$v
                                            )
                                          },
                                          expression: "formData.taxRate"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm.isOtros
                                ? _c(
                                    "div",
                                    { staticClass: "col-4" },
                                    [
                                      _c("label", [_vm._v("Monto Impuesto")]),
                                      _c("vs-input", {
                                        staticClass: "w-100",
                                        attrs: {
                                          type: "number",
                                          "data-cy": "tax-amount-input",
                                          size: "small"
                                        },
                                        on: { input: _vm.calculateTotals },
                                        model: {
                                          value: _vm.formData.taxAmountInput,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formData,
                                              "taxAmountInput",
                                              $$v
                                            )
                                          },
                                          expression: "formData.taxAmountInput"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _c(
                                "div",
                                { staticClass: "col-4" },
                                [
                                  _c("label", [
                                    _vm._v("Descuentos "),
                                    _c("span", { staticClass: "text-helper" }, [
                                      _vm._v("(Monto)")
                                    ])
                                  ]),
                                  _c("vs-input", {
                                    staticClass: "w-100",
                                    attrs: {
                                      type: "number",
                                      "data-cy": "discounts",
                                      size: "small"
                                    },
                                    on: { input: _vm.calculateTotals },
                                    model: {
                                      value: _vm.formData.discountAmountInput,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.formData,
                                          "discountAmountInput",
                                          $$v
                                        )
                                      },
                                      expression: "formData.discountAmountInput"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "div",
                                { staticClass: "col-4" },
                                [
                                  _c("label", [
                                    _vm._v("Recargos "),
                                    _c("span", { staticClass: "text-helper" }, [
                                      _vm._v("(Monto)")
                                    ])
                                  ]),
                                  _c("vs-input", {
                                    staticClass: "w-100",
                                    attrs: {
                                      type: "number",
                                      "data-cy": "charges",
                                      size: "small"
                                    },
                                    on: { input: _vm.calculateTotals },
                                    model: {
                                      value: _vm.formData.chargesAmountInput,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.formData,
                                          "chargesAmountInput",
                                          $$v
                                        )
                                      },
                                      expression: "formData.chargesAmountInput"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm.showRetentionField
                                ? _c(
                                    "div",
                                    { staticClass: "col-4" },
                                    [
                                      _c("label", [
                                        _vm._v("Retención de Impuesto (%)")
                                      ]),
                                      _c("vs-input", {
                                        staticClass: "w-100",
                                        attrs: {
                                          type: "number",
                                          "data-cy": "retentionTax",
                                          size: "small",
                                          min: "0",
                                          max: "100"
                                        },
                                        on: { input: _vm.calculateTotals },
                                        model: {
                                          value:
                                            _vm.formData.withholdingPercentage,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formData,
                                              "withholdingPercentage",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "formData.withholdingPercentage"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _c(
                                "div",
                                { staticClass: "col-4" },
                                [
                                  _c("label", [_vm._v("Valor otra moneda")]),
                                  _c("v-select", {
                                    attrs: {
                                      label: "label",
                                      options: _vm.otherCurrencies,
                                      reduce: function(currency) {
                                        return currency.label
                                      },
                                      name: "otherCurrency",
                                      placeholder: "Seleccione moneda"
                                    },
                                    model: {
                                      value: _vm.formData.otherCurrency,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.formData,
                                          "otherCurrency",
                                          $$v
                                        )
                                      },
                                      expression: "formData.otherCurrency"
                                    }
                                  })
                                ],
                                1
                              )
                            ])
                          ]),
                          _c("div", { staticClass: "col-12 mt-5" }, [
                            _c("h4", [_vm._v("SERVICIOS O PRODUCTOS")]),
                            _vm.errorItems
                              ? _c("small", { staticClass: "text-danger" }, [
                                  _vm._v(" Debes seleccionar al menos un ítem ")
                                ])
                              : _vm._e()
                          ]),
                          _c(
                            "div",
                            { staticClass: "col-12" },
                            [
                              _vm._l(_vm.formData.items, function(item, index) {
                                return _c(
                                  "div",
                                  { key: item.id, staticClass: "row mt-2" },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "col-1 d-flex align-items-center"
                                      },
                                      [
                                        item.selected === true
                                          ? _c(
                                              "b-button",
                                              {
                                                attrs: {
                                                  variant: "success",
                                                  size: "sm"
                                                },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.unSelectItem(
                                                      item
                                                    )
                                                  }
                                                }
                                              },
                                              [_vm._v(" selec. ")]
                                            )
                                          : _vm._e(),
                                        item.selected === false
                                          ? _c(
                                              "b-button",
                                              {
                                                attrs: {
                                                  variant: "secondary",
                                                  size: "sm"
                                                },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.selectItem(item)
                                                  }
                                                }
                                              },
                                              [_vm._v(" no selec. ")]
                                            )
                                          : _vm._e()
                                      ],
                                      1
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "col-5" },
                                      [
                                        _c("vs-input", {
                                          staticClass: "w-100",
                                          attrs: {
                                            label: "Nombre de servicio",
                                            "data-cy": "name-service"
                                          },
                                          model: {
                                            value: item.requiredServiceName,
                                            callback: function($$v) {
                                              _vm.$set(
                                                item,
                                                "requiredServiceName",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "item.requiredServiceName"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "col-3" },
                                      [
                                        _c("label", [
                                          _vm._v("Número de serie "),
                                          _c(
                                            "span",
                                            { staticClass: "text-helper" },
                                            [_vm._v("(Si corresponde)")]
                                          )
                                        ]),
                                        _c("vs-input", {
                                          staticClass: "w-100",
                                          attrs: { "data-cy": "serie-number" },
                                          model: {
                                            value: item.serieNumber,
                                            callback: function($$v) {
                                              _vm.$set(item, "serieNumber", $$v)
                                            },
                                            expression: "item.serieNumber"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "col-3" },
                                      [
                                        _c("label", [
                                          _vm._v("Encargado del bien "),
                                          _c(
                                            "span",
                                            { staticClass: "text-helper" },
                                            [_vm._v("(Si corresponde)")]
                                          )
                                        ]),
                                        _c(
                                          "v-select",
                                          {
                                            staticClass: "w-100",
                                            attrs: {
                                              options: _vm.users,
                                              name: "serviceManager",
                                              multiple: "",
                                              "data-vv-as":
                                                "encargado del bien",
                                              "data-cy": "service-manager"
                                            },
                                            model: {
                                              value: item.serviceManager,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  item,
                                                  "serviceManager",
                                                  $$v
                                                )
                                              },
                                              expression: "item.serviceManager"
                                            }
                                          },
                                          [
                                            _c(
                                              "template",
                                              { slot: "no-options" },
                                              [
                                                _vm._v(
                                                  " no hay coincidencias para el criterio de búsqueda "
                                                )
                                              ]
                                            )
                                          ],
                                          2
                                        )
                                      ],
                                      1
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "col-1" },
                                      [
                                        _c("vs-input", {
                                          staticClass: "w-100",
                                          attrs: {
                                            type: "number",
                                            label: "Cantidad",
                                            "data-cy": "quantity"
                                          },
                                          model: {
                                            value: item.serviceQuantity,
                                            callback: function($$v) {
                                              _vm.$set(
                                                item,
                                                "serviceQuantity",
                                                $$v
                                              )
                                            },
                                            expression: "item.serviceQuantity"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "col-2" },
                                      [
                                        _c("vs-input", {
                                          staticClass: "w-100",
                                          attrs: {
                                            type: "number",
                                            label: "Cant. entregada",
                                            "data-cy": "quantity-delivered"
                                          },
                                          on: {
                                            input: function($event) {
                                              return _vm.changeReceivedQuantity(
                                                item
                                              )
                                            }
                                          },
                                          model: {
                                            value:
                                              item.serviceQuantityDelivered,
                                            callback: function($$v) {
                                              _vm.$set(
                                                item,
                                                "serviceQuantityDelivered",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "item.serviceQuantityDelivered"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "col-3" },
                                      [
                                        _c("vs-input", {
                                          staticClass: "w-100",
                                          attrs: {
                                            type: "number",
                                            label: "Precio unitario",
                                            "data-cy": "unit-price"
                                          },
                                          on: {
                                            input: function($event) {
                                              return _vm.changeReceivedQuantity(
                                                item
                                              )
                                            }
                                          },
                                          model: {
                                            value: item.serviceAmount,
                                            callback: function($$v) {
                                              _vm.$set(
                                                item,
                                                "serviceAmount",
                                                $$v
                                              )
                                            },
                                            expression: "item.serviceAmount"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c("div", { staticClass: "col-3" }),
                                    _c(
                                      "div",
                                      { staticClass: "col-3" },
                                      [
                                        _c("vs-input", {
                                          staticClass: "w-100",
                                          attrs: {
                                            type: "number",
                                            label: "Precio total",
                                            "data-cy": "total-price",
                                            disabled: ""
                                          },
                                          model: {
                                            value: item.serviceTotalAmount,
                                            callback: function($$v) {
                                              _vm.$set(
                                                item,
                                                "serviceTotalAmount",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "item.serviceTotalAmount"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c("vs-divider")
                                  ],
                                  1
                                )
                              }),
                              _c("div", { staticClass: "row" }, [
                                _c("div", { staticClass: "col-9" }),
                                _c(
                                  "div",
                                  { staticClass: "col-3 text-right" },
                                  [
                                    _c(
                                      "b-button",
                                      {
                                        attrs: {
                                          variant: "outline-warning",
                                          size: "sm"
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.addItem()
                                          }
                                        }
                                      },
                                      [_vm._v(" agregar ")]
                                    )
                                  ],
                                  1
                                )
                              ])
                            ],
                            2
                          ),
                          _c("vs-divider"),
                          _c(
                            "div",
                            { staticClass: "col-12" },
                            [
                              _c(
                                "b-form-group",
                                { staticClass: "mt-0 mt-md-8" },
                                [
                                  _c(
                                    "b-form-checkbox",
                                    {
                                      staticClass: "m-0",
                                      attrs: {
                                        name: "applyPenalty",
                                        "data-cy": "apply-penalty",
                                        "data-vv-as": "aplica multa"
                                      },
                                      model: {
                                        value: _vm.formData.applyPenalty,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.formData,
                                            "applyPenalty",
                                            $$v
                                          )
                                        },
                                        expression: "formData.applyPenalty"
                                      }
                                    },
                                    [_vm._v(" Aplica multa ")]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm.formData.applyPenalty
                            ? _c(
                                "div",
                                { staticClass: "col-9" },
                                [
                                  _c("validate-field", {
                                    attrs: {
                                      field: "percentagePenalty",
                                      label: "Porcentaje de multa"
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function(ref) {
                                            var invalid = ref.invalid
                                            return [
                                              _c("b-input", {
                                                directives: [
                                                  {
                                                    name: "validate",
                                                    rawName: "v-validate",
                                                    value: {
                                                      required:
                                                        _vm.formData
                                                          .applyPenalty
                                                    },
                                                    expression:
                                                      "{ required: formData.applyPenalty }"
                                                  }
                                                ],
                                                attrs: {
                                                  name: "percentagePenalty",
                                                  placeholder:
                                                    "Detallar multa a aplicar (revisar contrato)",
                                                  "data-vv-as":
                                                    "porcentaje de multa",
                                                  "data-cy":
                                                    "percentage-penalty",
                                                  invalid: invalid
                                                },
                                                model: {
                                                  value:
                                                    _vm.formData
                                                      .percentagePenalty,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.formData,
                                                      "percentagePenalty",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "formData.percentagePenalty"
                                                }
                                              })
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      false,
                                      2824012000
                                    )
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.formData.applyPenalty
                            ? _c(
                                "div",
                                { staticClass: "col-3" },
                                [
                                  _c("validate-field", {
                                    attrs: {
                                      field: "daysPenalty",
                                      label: "Días de multa"
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function(ref) {
                                            var invalid = ref.invalid
                                            return [
                                              _c("b-input", {
                                                directives: [
                                                  {
                                                    name: "validate",
                                                    rawName: "v-validate",
                                                    value: {
                                                      required:
                                                        _vm.formData
                                                          .applyPenalty
                                                    },
                                                    expression:
                                                      "{ required: formData.applyPenalty }"
                                                  }
                                                ],
                                                attrs: {
                                                  name: "daysPenalty",
                                                  "data-vv-as": "días de multa",
                                                  "data-cy": "days-penalty",
                                                  invalid: invalid
                                                },
                                                model: {
                                                  value:
                                                    _vm.formData.daysPenalty,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.formData,
                                                      "daysPenalty",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "formData.daysPenalty"
                                                }
                                              })
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      false,
                                      3436502290
                                    )
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.formData.applyPenalty
                            ? _c("div", { staticClass: "col-12" }, [
                                _c(
                                  "small",
                                  { staticClass: "text-warning text-justify" },
                                  [
                                    _vm._v(
                                      " En el caso de que el proveedor incumpliese con el plazo de entrega del producto o servicio, calcular multa según lo establecido en Resolución, Contrato o Convenio Marco. "
                                    )
                                  ]
                                ),
                                _c("br"),
                                _c(
                                  "small",
                                  { staticClass: "text-warning text-justify" },
                                  [
                                    _vm._v(
                                      " El porcentaje mínimo de la multa aplicar, por cada día hábil o corrido de atraso, será de 0.5% y el porcentaje máximo será de 2.5% sobre el valor total neto de los bienes o servicios no entregados o prestados oportunamente. "
                                    )
                                  ]
                                ),
                                _c("br"),
                                _c(
                                  "small",
                                  { staticClass: "text-warning text-justify" },
                                  [
                                    _vm._v(
                                      " Las multas serán aplicadas sólo en compras o en contrataciones sobre 5 UTM, siempre y cuando el monto calculado de la multa sea superior a 1/3 de UTM. "
                                    )
                                  ]
                                )
                              ])
                            : _vm._e(),
                          _c("div", { staticClass: "col-6 mt-2" }, [
                            _vm.selectedDocument &&
                            _vm.selectedDocument.name &&
                            !_vm.selectedDocument.name.includes("FCA")
                              ? _c("div", { staticClass: "font-weight-bold" }, [
                                  _vm._v(
                                    " Total FISABS: " +
                                      _vm._s(
                                        _vm._f("amount")(
                                          _vm.formData.totalFisabs
                                        )
                                      ) +
                                      " "
                                  )
                                ])
                              : _vm._e()
                          ]),
                          _c("div", { staticClass: "col-6 mt-2" }, [
                            _c("div", { staticClass: "row" }, [
                              !_vm.isExempt
                                ? _c("div", { staticClass: "col-6 mt-3" }, [
                                    _vm._v(" Total Neto ")
                                  ])
                                : _vm._e(),
                              !_vm.isExempt
                                ? _c("div", { staticClass: "col-6 mt-3" }, [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm._f("amount")(
                                            _vm.formData.netAmount
                                          )
                                        ) +
                                        " "
                                    )
                                  ])
                                : _vm._e(),
                              _c("div", { staticClass: "col-6 mt-3" }, [
                                _vm._v(" Descuentos ")
                              ]),
                              _c("div", { staticClass: "col-6 mt-3" }, [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm._f("amount")(
                                        _vm.formData.discountAmount
                                      )
                                    ) +
                                    " "
                                )
                              ]),
                              _c("div", { staticClass: "col-6 mt-3" }, [
                                _vm._v(" Cargos ")
                              ]),
                              _c("div", { staticClass: "col-6 mt-3" }, [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm._f("amount")(
                                        _vm.formData.chargesAmount
                                      )
                                    ) +
                                    " "
                                )
                              ]),
                              _vm.showTaxLine
                                ? _c("div", { staticClass: "col-6 mt-3" }, [
                                    _vm._v(" " + _vm._s(_vm.taxTypeLabel) + " ")
                                  ])
                                : _vm._e(),
                              _vm.showTaxLine
                                ? _c("div", { staticClass: "col-6 mt-3" }, [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm._f("amount")(
                                            _vm.formData.taxAmount
                                          )
                                        ) +
                                        " "
                                    )
                                  ])
                                : _vm._e(),
                              _vm.showRetentionField
                                ? _c("div", { staticClass: "col-6 mt-3" }, [
                                    _vm._v(
                                      " Retención de Impuesto (" +
                                        _vm._s(
                                          _vm.formData.withholdingPercentage
                                        ) +
                                        "%) "
                                    )
                                  ])
                                : _vm._e(),
                              _vm.showRetentionField
                                ? _c("div", { staticClass: "col-6 mt-3" }, [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm._f("amount")(
                                            _vm.formData.retentionTax
                                          )
                                        ) +
                                        " "
                                    )
                                  ])
                                : _vm._e(),
                              _c("div", { staticClass: "col-6 mt-3" }, [
                                _vm._v(" Subtotal ")
                              ]),
                              _c("div", { staticClass: "col-6 mt-3" }, [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm._f("amount")(_vm.formData.subtotal)
                                    ) +
                                    " "
                                )
                              ]),
                              _vm.isExempt
                                ? _c("div", { staticClass: "col-6 mt-3" }, [
                                    _vm._v(" Monto Exento ")
                                  ])
                                : _vm._e(),
                              _vm.isExempt
                                ? _c("div", { staticClass: "col-6 mt-3" }, [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm._f("amount")(
                                            _vm.formData.exemptAmount
                                          )
                                        ) +
                                        " "
                                    )
                                  ])
                                : _vm._e(),
                              _c(
                                "div",
                                { staticClass: "col-6 mt-3 font-weight-bold" },
                                [_vm._v(" Total Recepción Conforme ")]
                              ),
                              _c("div", { staticClass: "col-6 mt-3" }, [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm._f("amount")(
                                        _vm.formData.totalGrossAmount
                                      )
                                    ) +
                                    " "
                                )
                              ])
                            ])
                          ]),
                          _c("div", { staticClass: "col-12" }, [
                            _c("h4", [_vm._v("DE LA RECEPCIÓN CONFORME")])
                          ]),
                          _c(
                            "div",
                            { staticClass: "col-6" },
                            [
                              _c(
                                "validate-field",
                                {
                                  attrs: {
                                    field: "location",
                                    label: "Ubicación del bien"
                                  }
                                },
                                [
                                  _c("select-options", {
                                    attrs: {
                                      multiple: "",
                                      name: "location",
                                      "data-vv-as": "ubicación del bien",
                                      "data-cy": "location",
                                      "options-group":
                                        "fisabs-service-delivery-location"
                                    },
                                    model: {
                                      value: _vm.formData.location,
                                      callback: function($$v) {
                                        _vm.$set(_vm.formData, "location", $$v)
                                      },
                                      expression: "formData.location"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm.formData.location &&
                          _vm.formData.location.includes(_vm.OTHER_ADDRESS)
                            ? _c(
                                "div",
                                { staticClass: "col-md-6 col-12" },
                                [
                                  _c("validate-field", {
                                    attrs: {
                                      field: "otherAddress",
                                      label: "Ingrese otra dirección"
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function(ref) {
                                            var invalid = ref.invalid
                                            return [
                                              _c("b-input", {
                                                directives: [
                                                  {
                                                    name: "validate",
                                                    rawName: "v-validate",
                                                    value: {
                                                      required: _vm.formData.location.includes(
                                                        _vm.OTHER_ADDRESS
                                                      )
                                                    },
                                                    expression:
                                                      "{ required: formData.location.includes(OTHER_ADDRESS) }"
                                                  }
                                                ],
                                                attrs: {
                                                  name: "otherAddress",
                                                  placeholder:
                                                    "Ingrese otra dirección",
                                                  "data-vv-as":
                                                    "otra dirección",
                                                  "data-cy": "other-address",
                                                  state: invalid
                                                },
                                                model: {
                                                  value:
                                                    _vm.formData.otherAddress,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.formData,
                                                      "otherAddress",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "formData.otherAddress"
                                                }
                                              })
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      false,
                                      896083069
                                    )
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _c("div", { staticClass: "col-12" }, [
                            _c("div", { staticClass: "row" }, [
                              _c(
                                "div",
                                { staticClass: "col-6" },
                                [
                                  _c(
                                    "label",
                                    { attrs: { for: "responsibleName" } },
                                    [
                                      _vm._v("Usuario responsable "),
                                      _c(
                                        "span",
                                        { staticClass: "text-danger" },
                                        [_c("b", [_vm._v("*")])]
                                      )
                                    ]
                                  ),
                                  _c(
                                    "v-select",
                                    {
                                      staticClass: "w-100",
                                      attrs: {
                                        options: _vm.users,
                                        name: "responsibleName",
                                        multiple: "",
                                        "data-vv-as": "responsable",
                                        "data-cy": "responsible-name"
                                      },
                                      on: { input: _vm.addResponsible },
                                      model: {
                                        value: _vm.formData.responsibles,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.formData,
                                            "responsibles",
                                            $$v
                                          )
                                        },
                                        expression: "formData.responsibles"
                                      }
                                    },
                                    [
                                      _c("template", { slot: "no-options" }, [
                                        _vm._v(
                                          " no hay coincidencias para el criterio de búsqueda "
                                        )
                                      ])
                                    ],
                                    2
                                  ),
                                  _vm.errorResponsible
                                    ? _c(
                                        "small",
                                        { staticClass: "text-danger" },
                                        [
                                          _vm._v(
                                            " Debes seleccionar al menos un responsable "
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ],
                                1
                              ),
                              _c(
                                "div",
                                { staticClass: "col-6 mt-2" },
                                [
                                  _c("validate-field", {
                                    attrs: {
                                      field: "responsibleUnit",
                                      label: "Unidad responsable"
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function(ref) {
                                            var invalid = ref.invalid
                                            return [
                                              _c("select-options", {
                                                directives: [
                                                  {
                                                    name: "validate",
                                                    rawName: "v-validate",
                                                    value: "required",
                                                    expression: "'required'"
                                                  }
                                                ],
                                                attrs: {
                                                  "alphabetical-sort": true,
                                                  "options-group":
                                                    "fisabs-requester-unit",
                                                  name: "responsibleUnit",
                                                  "data-vv-as":
                                                    "unidad responsable",
                                                  "data-cy": "responsible-unit",
                                                  invalid: invalid
                                                },
                                                model: {
                                                  value:
                                                    _vm.formData
                                                      .responsibleUnit,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.formData,
                                                      "responsibleUnit",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "formData.responsibleUnit"
                                                }
                                              })
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      false,
                                      790534851
                                    )
                                  })
                                ],
                                1
                              )
                            ])
                          ]),
                          _c(
                            "div",
                            { staticClass: "col-12" },
                            [
                              _c(
                                "b-form-group",
                                { attrs: { label: "Observaciones" } },
                                [
                                  _c("b-form-textarea", {
                                    attrs: {
                                      name: "observations",
                                      "data-cy": "observations",
                                      "data-vv-as": "observaciones",
                                      type: "text",
                                      rows: "2",
                                      maxLength: "10000"
                                    },
                                    model: {
                                      value: _vm.formData.observations,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.formData,
                                          "observations",
                                          $$v
                                        )
                                      },
                                      expression: "formData.observations"
                                    }
                                  }),
                                  _vm.formData.observations
                                    ? _c("div", { staticClass: "text-right" }, [
                                        _c(
                                          "small",
                                          {
                                            directives: [
                                              {
                                                name: "tooltip",
                                                rawName: "v-tooltip",
                                                value: "Contador de caracteres",
                                                expression:
                                                  "'Contador de caracteres'"
                                              }
                                            ]
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.formData.observations
                                                    .length
                                                ) +
                                                "/10000 "
                                            )
                                          ]
                                        )
                                      ])
                                    : _vm._e(),
                                  _vm.errors.has("formData.observations")
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "con-text-validation span-text-validation-danger v-enter-to",
                                          staticStyle: { height: "19px" }
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "span-text-validation"
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.errors.first(
                                                      "formData.observations"
                                                    )
                                                  ) +
                                                  " "
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c("div", { staticClass: "col-12" }, [
                            _vm._v(
                              " Por medio de la presente se da Recepción conforme a los bienes y servicios que se detallan en el presente instrumento "
                            )
                          ]),
                          _c("vs-divider"),
                          _c("div", { staticClass: "col-12" }, [
                            _c("h4", [_vm._v("Documentos")])
                          ]),
                          _c(
                            "div",
                            { staticClass: "col-12" },
                            [
                              !_vm.grcAttachmentsSelectors.loading
                                ? _c("dynamic-file-selector", {
                                    attrs: {
                                      selectors: _vm.grcAttachmentsSelectors.list
                                        .slice()
                                        .sort(function(a, b) {
                                          return a.order - b.order
                                        })
                                        .map(function(sel) {
                                          return Object.assign(
                                            {},
                                            sel,
                                            sel.extra,
                                            { index: sel.order }
                                          )
                                        }),
                                      "object-to-evaluate": _vm.formData,
                                      files: _vm.dynamicSelectorFiles,
                                      "reset-key": _vm.dfsResetKey
                                    },
                                    on: {
                                      "update-files": _vm.updateFiles,
                                      valid: function(valid) {
                                        _vm.dynamicFileSelectorValid = valid
                                      }
                                    }
                                  })
                                : _c(
                                    "div",
                                    [
                                      _c("b-skeleton", {
                                        attrs: {
                                          animation: "fade",
                                          width: "100%"
                                        }
                                      }),
                                      _c("b-skeleton", {
                                        attrs: {
                                          animation: "fade",
                                          width: "100%"
                                        }
                                      })
                                    ],
                                    1
                                  )
                            ],
                            1
                          ),
                          _c("div", { staticClass: "col-12" }, [
                            _c(
                              "div",
                              { staticClass: "row" },
                              [
                                _c(
                                  "div",
                                  { staticClass: "col-12" },
                                  [
                                    _c("UploadFile", {
                                      attrs: {
                                        permission: "*",
                                        accept:
                                          "application/pdf, .doc, .docx, .xlsx, .ppt",
                                        text: "Seleccionar documentos",
                                        "upload-to": "ed",
                                        "button-class": {
                                          "btn-block": true,
                                          "mb-5": _vm.errors.has(
                                            "custom-document.fileName"
                                          )
                                        },
                                        "container-class": "w-100"
                                      },
                                      on: {
                                        input: function($event) {
                                          return _vm.addOthersFile()
                                        }
                                      },
                                      model: {
                                        value: _vm.fileOthers,
                                        callback: function($$v) {
                                          _vm.fileOthers = $$v
                                        },
                                        expression: "fileOthers"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._l(_vm.formData.attachments, function(
                                  file
                                ) {
                                  return (!file.name ||
                                    !file.name.includes("FISABS")) &&
                                    file.origen === "adjunto"
                                    ? _c(
                                        "div",
                                        { key: file.id, staticClass: "col-3" },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "d-flex flex-column align-items-center"
                                            },
                                            [
                                              _c("vs-icon", {
                                                attrs: {
                                                  icon: "description",
                                                  size: "45px",
                                                  color: "primary"
                                                }
                                              }),
                                              _c(
                                                "b",
                                                {
                                                  staticClass:
                                                    "text-truncate w-100 text-center"
                                                },
                                                [_vm._v(_vm._s(file.name))]
                                              ),
                                              _c("vs-button", {
                                                attrs: {
                                                  color: "danger",
                                                  type: "flat",
                                                  icon: "clear"
                                                },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.removeOthersFile(
                                                      file.id
                                                    )
                                                  }
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                })
                              ],
                              2
                            )
                          ])
                        ],
                        1
                      )
                    : _vm._e()
                ]
              ),
              _c("div", { staticClass: "text-xs text-right" }, [
                _c("b", [
                  _vm._v("Los campos marcados con "),
                  _c("span", { staticClass: "text-danger" }, [_vm._v("*")]),
                  _vm._v(" son obligatorios")
                ])
              ]),
              _c("form-buttons", {
                attrs: {
                  saving: _vm.saving,
                  disabled: _vm.dfsSelectorsLoading,
                  back: function() {
                    return this$1.$router.back()
                  },
                  preview: _vm.preview,
                  save: _vm.save,
                  saveDraft: _vm.saveDraft
                }
              })
            ],
            1
          ),
      _c("repository-selector", {
        attrs: {
          "add-file": _vm.addRepositoryFile,
          files: _vm.attachments,
          "remove-file": _vm.removeRepositoryFile,
          "max-files": 1,
          "required-file-type": "FISABS,FCA",
          "required-approval-state": _vm.approvalStateTypes.APPROVED
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }